import { useMemo } from "react";
import { ListTeamDto } from "../models/team.models";
import { useSearch } from "./SearchBox.hook";

export function useFilteredTeams(teams: ListTeamDto[]) {
	const { query } = useSearch();

	const filteredTeams = useMemo(() => {
		if (query && query.length > 0) {
			const lowerQuery = query.toLowerCase();
			return teams?.filter(team =>
				(team.Name && team.Name.toLowerCase().includes(lowerQuery))) || [];
		} else {
			return teams || [];
		}
	}, [query, teams]);

	return { filteredTeams, showNoResults: query && query.length > 0 && filteredTeams.length === 0 };
}